import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './TextBanner.module.css';

type TextBannerProps = ComponentProps & {
	fields: {
		Header: Field<string>;
		Text: Field<string>;
	};
};

export default function TextBanner(props: TextBannerProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && !props.fields) {
		return <></>;
	}

	return (
		<section className="maxWidth padX padYL">
			<div className={styles.textBannerContainer}>
				<Text tag="h1" field={props.fields.Header} className={styles.textBannerHeader} />

				<Text tag="p" field={props.fields.Text} className={styles.textBannerText} />
			</div>
		</section>
	);
}
